<div>
    <div class="flex items-center justify-between border-b border-gray-200 mb-3 pb-1">
        <app-list-header title="eSign List" subTitle="Manage all your eSign Documents here">
            <div class="flex items-center gap-2">
                <app-common-button buttonClass="regularButton" buttonLabel="Upload"
                    (clickEvent)="openUploadOverlay()"></app-common-button>
            </div>
        </app-list-header>
    </div>
    <div>
        <table class="custom-table-list" aria-label="esign-documents">
            <ng-container>
                <tr class="custom-table-list-headings">
                    <th class="custom-col-width-50">eSigned By</th>
                    <th class="custom-col-width-30">eSigned At</th>
                    <th class="custom-col-width-20">Credits Used</th>
                    <th class="custom-col-width-20 th-last">Actions</th>
                </tr>
                <tr class="custom-table-list-row-main" *ngFor="let doc of logs; let index = index">
                    <td class="custom-col-width-50">{{ doc?.esignBy || doc?.emailAddress }}</td>
                    <td class="custom-col-width-30">{{ doc?.created | date: 'dd MMM yy, hh:mm:ss a' }}</td>
                    <td class="custom-col-width-20">{{ doc?.esignCredits }}</td>
                    <td class="custom-col-width-20">
                        <div *ngIf="doc?.actionType === 'eSign-success'" [ngbTooltip]="'View Document'"
                            tooltipClass="custom-tooltip" class="btn btn-sm me-2 b-btn view-doc-btn"
                            (click)="openDocumentModal(doc)">
                            <app-common-icon [faIcon]="faEye"
                                [loadingIcon]="loadingDocId === doc?._id"></app-common-icon>
                        </div>
                    </td>
                </tr>
            </ng-container>
            <tr class="custom-table-list-row-main" *ngIf="loadRecords">
                <td colspan="4" class="custom-col-width-100 text-danger d-flex justify-content-center py-4">
                    <app-common-icon [loadingIcon]="loadRecords"></app-common-icon>
                </td>
            </tr>
            <tr class="custom-table-list-row-main" *ngIf="!logs?.length && !loadRecords">
                <td colspan="4" class="custom-col-width-100 text-danger d-flex justify-content-center">No Records Found!</td>
            </tr>
        </table>
        <div *ngIf="historyErrorMessage"
            class="text-center text-danger text-sm mt-3 bg-red-50 py-2 border border-red-100 rounded">
            <p>{{ historyErrorMessage }}</p>
        </div>
    </div>
    <div class="footer-page-ination">
        <app-paginator [totalCount]="totalCount" (selectedPage)="onPageChange($event)"></app-paginator>
    </div>
    <ng-template #documentModal let-modal>
        <div class="modal-header popupHeader">
            <h6>View Document</h6>
            <img (click)="closeDocumentModal()" class="usersFilter__crossIcon cursor-pointer"
                src="../../../assets/images/user-management/Cross.svg" alt="close" />
        </div>
        <div class="modal-body barcode-preview-modal">
            <iframe *ngIf="selectedDocumentUrl" [src]="selectedDocumentUrl" width="100%" height="600px"
                title="Document-Preview"></iframe>
        </div>
    </ng-template>
</div>
